// import components
import Itinerary from '@/components/print/Itinerary'
import Parking from '@/components/print/Parking'
import GatePass from '@/components/print/GatePass'
import Invoice from '@/components/print/Invoice'

export default [
  {
    path: 'itinerary/:id',
    name: 'printItinerary',
    component: Itinerary
  },
  {
    path: 'parking/:id',
    name: 'printParking',
    component: Parking
  },
  {
    path: 'gatePass/:id',
    name: 'printGatePass',
    component: GatePass
  },
  {
    path: 'invoice/:id',
    name: 'printInvoice',
    component: Invoice
  }
]
